import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchUser } from '../../actions/auth.actions';
import {
  LOGIN_CHOOSE_METHOD_PATH,
  LOGIN_FIRST_TIME_SETUP_PATH,
  LOGIN_PATH,
  ROOT_PATH
} from '../../constants/paths.constants';
import { getQueryParams } from '../../lib/route.utils';
import {
  storeLoginMethod,
  storeLoginTime,
  storeRefreshToken,
  storeToken,
  storeTokenExpiration
} from '../../services/session.storage';

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = getQueryParams(location.search || '');

  useEffect(() => {
    if (params.token && params.token.length > 10) {
      storeToken(params.token);
      storeRefreshToken(params.refreshToken);
      storeTokenExpiration(params.expiration);
      storeLoginMethod(params.method);
      storeLoginTime(new Date().valueOf());

      dispatch(
        fetchUser((profile) => {
          if (profile?.user?.isFirstLogin) {
            return navigate(`${LOGIN_FIRST_TIME_SETUP_PATH}?fromUrl=${params.fromUrl}${location.search || ''}`);
          }
          if (params.fromUrl && params.fromUrl !== LOGIN_PATH) {
            return navigate(params.fromUrl);
          }
          return navigate(ROOT_PATH);
        })
      );
    } else {
      navigate(`${LOGIN_CHOOSE_METHOD_PATH}?fromUrl=${params.fromUrl || ''}`);
    }
  }, [
    navigate,
    dispatch,
    location,
    params.method,
    params.token,
    params.fromUrl,
    params.expiration,
    params.refreshToken
  ]);

  return <h1 className="u-margin-top-xx u-text-center">Inloggen...</h1>;
}

export default Login;
